(function($) {

	$('.slides').owlCarousel({
		singleItem: true,
		autoPlay: true,
		navigation: false,
		pagination: false,
		autoHeight: false,
		transitionStyle : "fade",
	});

})( jQuery );